import { render, staticRenderFns } from "./LicenseItemAuthorizations.vue?vue&type=template&id=62fc1575&scoped=true&"
import script from "./LicenseItemAuthorizations.vue?vue&type=script&lang=js&"
export * from "./LicenseItemAuthorizations.vue?vue&type=script&lang=js&"
import style0 from "./LicenseItemAuthorizations.vue?vue&type=style&index=0&id=62fc1575&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fc1575",
  null
  
)

export default component.exports